<div class="edit-cell" (click)="btnClickedHandler($event)">
    <i class="material-icons">edit</i>
</div>